// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"4815cdd0","375":"80680470","453":"6cd71db7","503":"d8738783","569":"60022579","592":"24fcbb36"}[chunkId] + ".chunk.js";
};